function transactions (apiConfig) {
  return {
    getDiscounts () {
      const rq = apiConfig.context.$http.get(
        'v1/discounts',
        apiConfig.requestObj()
      )
      return apiConfig.buildPromise(rq)
    },
    getTaxRate (zip) {
      const rq = apiConfig.context.$http.get(
        'v1/get-tax-rate/'+zip,
        apiConfig.requestObj()
      )
      return apiConfig.buildPromise(rq)
    },
    makeTransaction (
      payAmount,
      description,
      accessId,
      transactionToken,
      currency = 'USD',
      destination = null,
      useCapture = true
    ) {
      let dt = {
        currency,
        description,
        accessId,
        amount: payAmount, //stripe uses an int [with shifted decimal place] so we must convert our payment amount
        capture: useCapture,
        token: transactionToken,
      }
      var route = 'v1/transactions/charge/card/'
      if (destination) {
        route = route + 'direct/' + destination + '/'
      }
      const rq = apiConfig.context.$http.post(route, dt, apiConfig.requestObj())
      return apiConfig.buildPromise(rq)
    },
    startSubscription (paymentMethod, priceId, accessId, destination = null) {
      const formData = { paymentMethod, priceId, accessId, destination }
      const route = '/v1/transactions/subscription/'
      const rq = apiConfig.context.$http.post(
        route,
        formData,
        apiConfig.requestObj()
      )
      return apiConfig.buildPromise(rq)
    },
    checkoutSuccess (comboId) {
      const route = '/v1/transactions/checkout/' + comboId + '/success/'
      const rq = apiConfig.context.$http.get(route, apiConfig.requestObj())
      return apiConfig.buildPromise(rq)
    },
    createCheckout (
      paymentMethods,
      mode,
      quantity,
      currency,
      cancelUrl,
      successUrl,
      payAmount,
      description,
      name,
      priceId,
      accessId,
      taxRate
    ) {
      const formData = {
        paymentMethods,
        mode,
        quantity,
        currency,
        cancelUrl,
        successUrl,
        payAmount,
        description,
        name,
        priceId,
        accessId,
        taxRate,
      }
      const route = '/v1/transactions/checkout/'
      const rq = apiConfig.context.$http.post(
        route,
        formData,
        apiConfig.requestObj()
      )
      return apiConfig.buildPromise(rq)
    },
  }
}
export default transactions
